import Window from './Window.jsx';
export default Window;
